import { render, staticRenderFns } from "./SkeletonTable.vue?vue&type=template&id=73141e17&scoped=true&"
import script from "./SkeletonTable.vue?vue&type=script&lang=js&"
export * from "./SkeletonTable.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonTable.vue?vue&type=style&index=0&id=73141e17&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73141e17",
  null
  
)

export default component.exports